module.exports = __webpack_public_path__ + "static/img/taras.3f76ca5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taras.jpg
// module id = aDNF
// module chunks = 1